import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types'; // Material UI

import KeyboardArrowRightRoundedIcon from '@material-ui/icons/KeyboardArrowRightRounded';
import { Breadcrumbs, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function (theme) {
  return {
    breadcrumb: {
      color: theme.palette.primary.main,
      marginBottom: theme.spacing(1)
    },
    separator: {
      color: '#f44336',
      marginLeft: '2px',
      marginRight: '2px'
    }
  };
});
export var BreadCrumb = function BreadCrumb(_ref) {
  var crumbRenderer = _ref.crumbRenderer,
      crumbs = _ref.crumbs;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Breadcrumbs, {
    className: classes.breadcrumb,
    classes: {
      separator: classes.separator
    },
    separator: /*#__PURE__*/React.createElement(KeyboardArrowRightRoundedIcon, {
      className: classes.separator
    })
  }, crumbs.map(function (crumb) {
    return crumbRenderer ? crumbRenderer(crumb) : /*#__PURE__*/React.createElement(Typography, {
      key: crumb.name
    }, crumb.name);
  }));
};
BreadCrumb.propTypes = {
  crumbRenderer: PropTypes.func,
  crumbs: PropTypes.array.isRequired
};